module.exports = __webpack_public_path__ + "img/product_16.3150a94.svg";